import React, { useState } from 'react';

import useTranslationLgs from '@hooks/i18n/useTranslation';
import RingilSidebar from '@components/ringil3/Sidebar/RingilSidebar.tsx';

interface ComponentProps {}

export const useCreateSettingsSidebar = () => {
  const [visible, setVisible] = useState(false);

  const SettingsSidebar: React.FC<ComponentProps> = ({ children }: any) => {
    //const { addNewPersionEntry } = useContext(ApiContext);
    const { tr } = useTranslationLgs();

    return (
      <RingilSidebar
        visible={visible}
        heading={tr('TimeslotReservations.AdjustCalendarStyle', 'Adjust Calendar Style')}
        onBack={() => setVisible(false)}
        onContinue={() => setVisible(false)}
        showBackButton={false}
      >
        {children}
      </RingilSidebar>
    );
  };

  return { SettingsSidebar, visible, setVisible };
};
